// src/pages/ArtPage.jsx
import HeroSection from "../components/art/HeroSection";
import BrandIntroSection from "../components/art/BrandIntroSection";
import ArtworkSection from "../components/art/ArtworkSection";
import ProgramSection from "../components/art/ProgramSection";
import NewsSection from "../components/art/NewsSection";
import ActivitySection from "../components/art/ActivitySection";
import FloatingContactButtons from "../components/common/FloatingContactButtons";
import TrainingCooperationSection from "../components/art/TrainingCooperationSection";
import GlobalImpactSection from "../components/art/GlobalImpactSection";
import RevealSection from "../components/common/RevealSection";

function ArtPage() {
  return (
    <div className="art-page">
      <HeroSection />

      <RevealSection delay={0.1}>
        <BrandIntroSection />
      </RevealSection>

      <RevealSection delay={0.2}>
        <ProgramSection />
      </RevealSection>

      <RevealSection delay={0.3}>
        <ArtworkSection />
      </RevealSection>

      <RevealSection delay={0.4}>
        <NewsSection />
      </RevealSection>

      <RevealSection delay={0.5}>
        <ActivitySection />
      </RevealSection>

      <RevealSection delay={0.6}>
        <GlobalImpactSection />
      </RevealSection>

      <RevealSection delay={0.7}>
        <TrainingCooperationSection />
      </RevealSection>

      <FloatingContactButtons />
    </div>
  );
}

export default ArtPage;
